module.exports = __webpack_public_path__ + "static/home_1-667b563601325d221d41247ef4c68417.png";